const COLORS = {
  BRAND_BLUE: "#1450F5",
  TEXT_BLACK: "#3D3D3D",
  TEXT_WHITE: "#FFFFFF",
  TEXT_GRAY: "#676767",
  BTN_TEXT_BLUE: "#2350F5",
  LABEL_GREY: "#C2C5CB",
  BUTTON_GREY: "#F1F4FD",
  BUTTON_BLUE: "#2350F5",
  IMAGE_BORDER_BLUE: "#2450F5",
  BUTTON_BORDER: "#E2EBFC",
  ERROR_RED: "#d32f2f",
  INACTIVE_YELLOW: "#FEDE4C",
  BLOCKED_RED: "#FA5332",
};

const ADMIN_ROLES = {
  SUBCON_ADMIN: "SUBCON_ADMIN",
  SUPER_ADMIN_USER: "SUPER_ADMIN_USER",
  SUPERVISOR_USER: "SUPERVISOR_USER",
  AREA_KEY_USER: "AREA_KEY_USER",
  FL_KEY_USER: "FL_KEY_USER",
  FL_TRAINER: "FL_TRAINER",
};

export const CONSTANTS = {
  COLORS: COLORS,
  SUPERVISOR_USER: "SUPERVISOR_USER",
  SUPER_ADMIN_USER: "SUPER_ADMIN_USER",
  FL_KEY_USER: "FL_KEY_USER",
  FL_TRAINER: "FL_TRAINER",
  AREA_KEY_USER: "AREA_KEY_USER",
  USER_ACTION: {
    LOGIN: "login",
    LOGOUT: "logout",
    QR_CODE: "qrcode",
    PROFILE: "profile",
  },
  STATUS: {
    ACTIVE: "active",
    INACTIVE: "inactive",
    BLOCKED: "blocked",
  },
  STATUS_ICONS: {
    ACTIVE: "/icon_status_active.svg",
    INACTIVE: "/icon_status_inactive.svg",
    BLOCKED: "/icon_blocked.svg",
  },
  STATUS_BG_COLORS: {
    ACTIVE: "#59AB46",
    INACTIVE: "#FFDE4C",
    BLOCKED: "#FF0000",
  },
  STATUS_TEXT_COLORS: {
    ACTIVE: COLORS.TEXT_WHITE,
    INACTIVE: COLORS.TEXT_BLACK,
    BLOCKED: COLORS.TEXT_WHITE,
  },
  ADMIN_ROLES: ADMIN_ROLES,
};
